import React from 'react'

import MobileModal, { MobileModalProps } from '../MobileModal'
import ClientChatPanel from '../../../../pages/ClientChats/ClientChatPanel'

import useStyles from './styles'

interface MobileSelectViewModalProps
  extends Omit<MobileModalProps, 'title' | 'children'> {}

const MobileSelectViewModal: React.FC<MobileSelectViewModalProps> = props => {
  const classes = useStyles()

  return (
    <MobileModal title='Views' {...props}>
      <ClientChatPanel onClick={props.onClose} className={classes.root} />
    </MobileModal>
  )
}

export default MobileSelectViewModal
